import React from 'react';
import SEO from '../../../common/SEO';
import Layout from '../../../common/Layout';
import BreadcrumbOne from '../../../common/breadcrumb/BreadcrumbOne';
import RegisterProgramForm from '../../../components/form/register-program-form/RegisterProgramForm';
// import { Link } from 'react-router-dom';

const EventData = [
	{
		"id": 1,
		"title": "Crop Disease Detection",
		"image": "crop_disease_detection.webp",
		// "website": "https://ovet.app/",
		// "industry": "Healthcare",
		// "rating": "4.8 Google Rating",
		// "duration": "12 Weeks",
		"category": "Agriculture",
		"location": "https://pathoscan.com/",
		// "going": "140+",
		"company": "PathoScan"
	}
]

const CropDiseaseDetection = ({
	showRegisterForm,
	setShowRegisterForm,
	company
	}) => {
	const eventItem = EventData[0];
	return (
		<>
			<SEO
				title={ eventItem.title }
				description=""
			/>
			<Layout>
				<BreadcrumbOne 
					title={eventItem.title}
					rootUrl="/programs/work-integrated-learning"
					parentUrl="Industry Partner Work Integrated Learning"
					currentUrl={eventItem.title}
				/>
				<div className="edu-event-details-area edu-event-details edu-section-gap bg-color-white">
					<div className="container">
						<div className="row g-5">
							<div className="col-lg-12">
								<div className="thumbnail">
									<img src={`${process.env.PUBLIC_URL}/images/project-details/${ eventItem.image }`} alt="Event Thumb" />
								</div>
							</div>
						</div>
						<div className="row g-5">
							<div className="col-lg-7">
								<div className="content">
									<h3 className="title">{ eventItem.title }</h3>
									<p>
										<strong>What is the main goal for this project?</strong><br></br>
										This project explores how artificial intelligence can be used to support early detection of plant health issues in agricultural settings. The goal is to build a cloud-based machine learning system that analyzes plant diagnostic images to detect early signs of stress or disease—helping improve decision-making and reduce crop losses.
									</p>
									<p className="mb-0">
										<strong>What tasks will learners need to complete to achieve the project goal?</strong><br></br>
									</p>
									<ul>
										<li>
											Organize and preprocess image datasets captured from plant health diagnostics.
										</li>
										<li>
											Extract visual and color-based features from plant imagery.
										</li>
										<li>
											Train machine learning models to classify plant health status.
										</li>
										<li>
											Build data pipelines for processing and storing analysis results.
										</li>
										<li>
											Evaluate model accuracy, reliability, and response time in cloud environments.
										</li>
									</ul>
									<p className="mb-0">
										These tasks give learners hands-on experience in agri-AI, image analysis, and ML workflow design.
									</p>
									<p className="mb-0">
										<strong>How will you support learners in completing the project?</strong><br></br>
										Participants will receive mentorship from experienced data scientists and project advisors. They'll have access to real-world data (anonymized), cloud computing tools, and step-by-step guidance. Weekly check-ins, shared documentation, and technical feedback will support their learning journey from experimentation to deployment.
									</p>
								</div>
							</div>
							<div className="col-lg-5">
								<div className="eduvibe-sidebar">
									<div className="eduvibe-widget eduvibe-widget-details">
										<h5 className="title">ABOUT INDUSTRY PARTNER</h5>
										<div className="widget-content">
											<ul>
												{/* <li><span><i className="icon-Campus"></i> { eventItem.company }</span></li> */}
												<li><span><i className="icon-Campus"></i> <a href={eventItem.location}>{ eventItem.company }</a></span></li>
												<li><span><i className="icon-presentation"></i> { eventItem.category }</span></li>
												{/* <li><span><i className="icon-map-pin-line"></i> {company ? <a href={eventItem.location}>Website</a> : eventItem.location}</span></li> */}
												<li>
													PathoScan provides an on-site crop disease detection solution combining rapid DNA amplification with AI-powered analysis. Farmers receive test results and treatment guidance within hours, enabling timely interventions and reduced crop loss. Designed for greenhouse producers and agronomists, PathoScan streamlines diagnostics and boosts agricultural productivity.
												</li>
											</ul>
											{!company && <div className="read-more-btn mt--45">
												<a className="edu-btn btn-secondary text-center" href="https://form.jotform.com/m2mtech/wil-programs-sign-up">Register Now<i className="icon-arrow-right-line-right"></i></a>
											</div>}
										</div>
									</div>
								</div>
							</div>
							{!company && <div className="col-lg-12">
								<div className="read-more-btn text-center">
									<a className="edu-btn btn-secondary text-center" href="https://form.jotform.com/m2mtech/wil-programs-sign-up">Register Now<i className="icon-arrow-right-line-right"></i></a>
								</div>
							</div>}
						</div>
					</div>
				</div>
			</Layout>
			{showRegisterForm && <RegisterProgramForm setShowRegisterForm={setShowRegisterForm} />}
		</>
	)
}
export default CropDiseaseDetection;